import { createGlobalStyle } from "styled-components";

export const GlobalVariables = createGlobalStyle`
	:root {
		--error: #e42f03;
		--on-error: #e63f17;
		--error-container: #93000a;

		--inverse-on-surface: #2e312e;

		--navicon: #aaaca7;

		--on-primary-container: #94ffcf;
		--on-success-container: #57ff03;
		--on-secondary-container: #d2e8d4;
		--on-tertiary-container: #beeaf6;
		--on-warning-container: #ffdea4;

		--outline: #8b9389;
		--outline-inactive: #8b938951;
		--outline-hover: #8b938999;
		--outline-variant: #30372f;

		--primary: #03ff8f;
		--primary-container: #013d22;
		--primary-dark: #00542f;
		--primary-darker: #012918;
		--secondary: #b8ccb6;
		--tertiary: #a2ced9;
		--on-tertiary: #01363f;
		--big-chip-bg: #013d22;

		--success-container: #1a4d00;

		--surface: #141414;
		--on-surface: #e0e0e0;
		--on-surface-variant: #c1c9be;
		--on-secondary: #223527;
		--on-primary: #1e1e1e;

		--surface-container: #1f1f1f;
		--surface-container-low: #1f1f1f;
		--surface-container-lowest: #1a1a1a;
		--surface-container-high: #292929;
		--surface-container-highest: #333333;

		--text-heading-title: #f0f1ec;

		--warning-container: #5d4200;

		--dark-tint: rgba(0, 0, 0, 0.08);
		--black: rgba(0, 0, 0, 1);

		--text-paragraph: #aaaca7;
		--text-subheading: #8f918d;
		--text-heading: #f0f1ec;
		--text-title: #f0f1ec;

		--scrim: #000;

		--light-gray: #d3d3d3;
		--system-warning: #FBBC2C;
		--page-background: #0B0C0B;
		--secondary-container: #384B3C;

	}
`;
